import axios from "axios";

export const requestSaveBureauDetails = (data) =>
  axios.post(
    `/api/route?path=in-school/application/bureau-mismatch-details`,
    data
  );
